import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TURNSTILE_TOKEN } from './turnstile.context';

export const turnstileInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const token = req.context.get(TURNSTILE_TOKEN);

  if (token && req.url.toLowerCase().includes('/api/v2/auth/register')) {
    return next(req.clone({ setHeaders: { 'X-Turnstile-Token': token } }));
  }

  return next(req);
};
